import React from 'react';

// Material UI
import { green } from '@mui/material/colors'
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';

const IconCheck = ({ value }) =>
    value
        ? <CheckIcon style={{ color: green[500] }} />
        : <ClearIcon color="error" />

export default IconCheck;
